<template>
  <b-modal
    :visible="visible"
    :hide-footer="true"
    @hidden="visible = false"
  >
    <i
      v-if="loading"
      class="fa fa-circle-o-notch fa-spin text-muted"
    ></i>
    <div
      v-if="images.length && !loading"
    >
      <div
        v-for="(image, index) in images"
        v-bind:key="image.id"
      >
        <div class="media">
          <div class="media-left">
            <div class="mr-3">
              <img :src="image.urls.protected" width="80">
            </div>
          </div>
          <div class="media-body">
            <div class="small font-weight-bold">{{ image.name }}</div>
            <div class="text-muted">
              {{ fileSize(image.size) }}
            </div>
            <div>
              <span
                v-if="image.attachment.scope"
                class="badge badge-dark"
              >
                {{ image.attachment.scope }}
              </span>
            </div>
          </div>
          <div class="media-right">
            <b-dropdown variant="white" size="sm" right>
              <template v-slot:button-content>
                <i class="fa fa-cog"></i>
              </template>
              <b-dropdown-item
                v-if="canManage"
                :disabled="image.scope === 'profile'"
                @click.prevent="setProfileImage(image.attachment.id)"
              >
                Set as profile photo
              </b-dropdown-item>
              <b-dropdown-item
                v-if="canManage"
                @click.prevent="download(image.urls.protected)"
              >
                Download
              </b-dropdown-item>
              <b-dropdown-divider
                v-if="canManage"
              ></b-dropdown-divider>
              <b-dropdown-item
                @click.prevent="removeAttachment(image.attachment.id)"
              >
                Remove
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <hr v-if="index < images.length-1">
      </div>
    </div>
    <div
      v-if="images.length < 1 && !loading"
    >
      This user has no images.
    </div>
    <div
      v-if="canManage"
    >
      <hr>
      <div
        v-show="!uploading"
        class="buttons"
      >
        <upload
          variant="sm btn-white"
          :url="uploadUrl"
          attachable-type="App\User"
          :attachable-id="userId"
          @uploading="onUploading()"
          @uploaded="onUploaded(arguments[0])"
          @error="onError()"
        ></upload>
        <button
          class="ml-1 btn btn-sm btn-white"
          @click.prevent="chooseFromDropbox()"
        >
          <i class="fa fa-dropbox mr-1"></i>
          Choose from Dropbox...
        </button>
      </div>
      <div
        v-if="uploading"
      >
        <i class="fa fa-circle-o-notch fa-spin text-muted"></i>
      </div>
    </div>
    <div
      v-if="error"
      class="alert alert-danger mt-3 mb-0"
    >
      {{ error }}
    </div>
  </b-modal>
</template>

<script>
import Upload from '@/components/Upload'
import api from '@/api'
import urls from '@/api/urls'
import { fetchAndSave, getImages, setAttachmentScope, removeAttachment } from '@/api'
import { map } from 'lodash'
import numeral from 'numeral'
import alertify from 'alertify.js'

export default {
  components: {
    Upload
  },
  props: {
    canManage: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      uploadUrl: api.defaults.baseURL + '/' + urls.upload.image(),
      loading: false,
      uploading: false,
      profilePhoto: [],
      images: [],
      error: null,
      visible: this.value
    }
  },
  watch: {
    value () {
      this.visible = this.value
    },
    userId () {
      this.loadUserImages()
    },
    visible () {
      this.$emit('input', this.visible)
    }
  },
  mounted () {

  },
  methods: {
    chooseFromDropbox () {
      var vm = this
      window.Dropbox.choose({
        success (files) {
          vm.onChosenFromDropbox(files)
        },
        cancel () {
          //
        },
        linkType: 'direct',
        multiselect: true,
        extensions: ['images'],
        folderselect: false
      })
    },
    onError () {
      this.error = 'Oops! Something went wrong. Please try again later.'
      this.uploading = false
    },
    onUploading () {
      this.error = null
      this.uploading = true
    },
    onUploaded (file) {
      console.log(file)
      this.uploading = false
      this.loadUserImages()
    },
    async onChosenFromDropbox (files) {
      this.error = null
      this.uploading = true
      try {
        let response = await fetchAndSave(
          map(files, (file) => {
            return {
              url: file.link
            }
          }),
          true,
          'App\\User',
          this.userId
        )
        this.loadUserImages()
      } catch (e) {
        this.error = 'Oops! Something went wrong. Please try again later.'
      } finally {
        this.uploading = false
      }
    },
    async loadUserImages () {
      this.loading = true
      let response = await getImages('App\\User', this.userId)
      this.images = response.data.data
      this.loading = false
    },
    fileSize (bytes) {
      return numeral(bytes).format('0.0b')
    },
    download (url) {
      document.location = url
    },
    async setProfileImage (attachmentId) {
      this.loading = true
      await setAttachmentScope(attachmentId, 'profile')
      this.loadUserImages()
    },
    removeAttachment (attachmentId) {
      alertify.confirm('Are you sure you want to remove this image?', () => {
        removeAttachment(attachmentId).then(() => {
          this.loadUserImages()
        })
      })
    }
  }
}
</script>